/* eslint-disable max-len */
import React, { useContext } from 'react'
import { makeStyles } from '@mui/styles'
import { Checkbox, FormControlLabel, FormGroup, FormHelperText, Theme, Typography } from '@mui/material'
import CustomButton from '../../components/CustomButton'
import { loanContext } from './LoanJourney'

const useStyles = makeStyles(({ spacing }: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    textAlign: 'center',
    padding: spacing(3),
    justifyContent: 'space-evenly',
  },
  title: {
    paddingBottom: spacing(3),
  },
  consentContainer: {
    height: '300px',
    overflowY: 'scroll',
    border: '1px #bdbdbd solid',
    scrollbarColor: 'black',
    scrollBehavior: 'smooth',
    whiteSpace: 'pre-line',
    textAlign: 'right',
    fontFamily: 'fantasy',
  },
}), { name: 'ConsentForm' })

const consentData = 'לשם בחינה מהירה ואיכותית של בקשת ההלוואה שלך, נבקשך לאשר לנו גישה לדו"ח נתוני האשראי כמפורט בטופס מטה.\n' + 'הנני מצהיר בזה כי אני נותן בזה את הסכמתי לכך שנתוני האשראי לגבי הכלולים במאגר יימסרו ללשכת אשראי לשם עריכת דוח אשראי שיימסר לבלנדר פי2פי ישראל בע"מ, לשם התקשרות בעסקת אשראי או לשם הבטחת קיום העסקה, כמפורט להלן.\n עסקת אשראי חדשה (ניתן למלא יותר מערך אחד):\n [ ]מסגרת עובר ושב\n [ ]מסגרת אשראי מתחדשת\n [X]קו אשראי\n [ ]הלוואה\n [ ]משכנתא\n ערבות הסכמתי זו תעמוד בתוקפה עד תאריך\n 08-11-2021 ואם העסקה תצא לפועל עד מועד סיום עסקת האשראי.\nידוע לי שנתוני האשראי הכלולים לגביי במאגר כוללים, בין השאר, נתונים לגבי עסקאות אשראי שביצעתי וכן נתונים שונים מכונס הנכסים הרשמי, הוצאה לפועל ובנק ישראל.\n שים לב:נתוני האשראי האמורים יוכלו לשמש את לשכת האשראי גם למתן שירותים לנותן האשראי, לרבות דירוג אשראי או ייעוץ, לתקופה שהוסכמה לעיל, והכל בכפוף לחוק.\n מסירת המידע תלויה בהסכמתך, ואין אתה חייב לתת את הסכמתך.\nחתימה על הסכמה זו תתבצע באמצעות אימות פרטי כרטיס האשראי שלך, האימות מתבצע בטכנולוגיה מתקדמת ומאובטחת.\n כרטיסך לא יחויב (למרות שייתכן ותקבל סמס על כך מחברת האשראי).\n הנך רשאי לבחור את מועד סיום האישור, לביצוע השינוי, פנה לשירות הלקוחות.\n' + ''

const ConsentForm = (): JSX.Element => {
  const classes = useStyles()

  const {
    setStage,
    errorMessage,
    setErrorMessage,
    isConfirmTerms,
    setIsConfirmTerms,
  } = useContext(loanContext)

  const validateForm = (): boolean => {
    let msg = ''
    let valid = true

    if (!isConfirmTerms) {
      msg = 'אנא אשר את התנאים'
      valid = false
    }

    setErrorMessage(msg)

    return valid
  }

  const handleClickContinue = (): void => {
    if (validateForm()) {
      setStage((prev) => prev + 1)
    }
  }

  return (
    <div className={classes.root} dir='rtl'>
      <Typography variant='h5' className={classes.title}>הסכמה לשיתוף מידע</Typography>
      <div>
        <FormHelperText sx={{ display: 'flex', justifyContent: 'right', color: 'gray' }}>
          גלול כדי לאשר
        </FormHelperText>
        <div className={classes.consentContainer}>
          <Typography variant='h6'>{'דו"ח נתוני אשראי:'}</Typography>
          {consentData}
        </div>
      </div>
      <FormGroup sx={{ flex: 1 }}>
        <FormControlLabel
          label="קראתי ואני מאשר את תנאי השימוש"
          control={
            <Checkbox
              checked={isConfirmTerms}
              onChange={() => setIsConfirmTerms((prev) => !prev)}
            />}
          labelPlacement='end'
        />
        <FormHelperText error sx={{ display: 'flex', justifyContent: 'center' }}>
          {errorMessage}
        </FormHelperText>
      </FormGroup>
      <CustomButton onClick={handleClickContinue}>
        המשך
      </CustomButton>
    </div>
  )
}

export default ConsentForm
